






























































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import manychatLogsModule from "@/store/modules/manychat_logs-module";
import { manychat_mensajes_log } from "@/shared/dtos/manychat_mensajes_log";
import { recordatorio_cita_log } from "@/shared/dtos/recordatorio_cita_log";

@Component({ name: "ManyChatLogsViewer" })
export default class ManyChatLogsViewer extends Vue {
  public activeTab: number = 0;

  // ── Loading flags ──
  public loadingM: boolean = false;
  public loadingR: boolean = false;

  // ── Date picker menus ──
  public menuFechaDesdeM: boolean = false;
  public menuFechaHastaM: boolean = false;
  public menuFechaDesdeR: boolean = false;
  public menuFechaHastaR: boolean = false;

  // ── Filtros ──
  public filtroM = { fecha_desde: null as string | null, fecha_hasta: null as string | null, tipo_mensaje: null as string | null, estado_envio: null as string | null };
  public filtroR = { fecha_desde: null as string | null, fecha_hasta: null as string | null, tipo_recordatorio: null as string | null, estado_envio: null as string | null };

  // ── Detalle drawer ──
  public detalleOpen: boolean = false;
  public detalleItem: manychat_mensajes_log | recordatorio_cita_log | null = null;
  public detalleEsTipo: string = "";

  // ── Catálogos de filtro ──
  public estadosEnvio = [
    { text: "Enviado", value: "enviado" },
    { text: "Error", value: "error" },
  ];

  public tiposMensaje = [
    { text: "Solicitud en proceso", value: "solicitud_procesando" },
    { text: "Cita confirmada", value: "cita_confirmada" },
    { text: "Cita rechazada", value: "cita_rechazada" },
    { text: "Cita cancelada (admin)", value: "cita_cancelada_admin" },
    { text: "Cancelación (paciente)", value: "cancelacion_paciente" },
    { text: "Recordatorio 120h", value: "recordatorio_120h" },
    { text: "Recordatorio 72h", value: "recordatorio_72h" },
    { text: "Recordatorio 24h", value: "recordatorio_24h" },
    { text: "Recordatorio 2h", value: "recordatorio_2h" },
  ];

  public tiposRecordatorio = [
    { text: "120h — 5 días antes", value: "120h" },
    { text: "72h — 3 días antes", value: "72h" },
    { text: "24h — 1 día antes", value: "24h" },
    { text: "2h — 2 horas antes", value: "2h" },
  ];

  // ── Headers tablas ──
  public headersMensajes = [
    { text: "Fecha", value: "created_at", width: "160px" },
    { text: "Tipo", value: "tipo_mensaje", width: "200px" },
    { text: "Teléfono", value: "telefono", width: "140px" },
    { text: "Cita", value: "id_solicitud", width: "90px" },
    { text: "Estado", value: "estado_envio", width: "110px" },
    { text: "", value: "acciones", sortable: false, align: "center", width: "50px" },
  ];

  public headersRecordatorios = [
    { text: "Fecha", value: "created_at", width: "160px" },
    { text: "Tipo", value: "tipo_recordatorio", width: "160px" },
    { text: "Teléfono", value: "telefono", width: "140px" },
    { text: "Cita", value: "id_solicitud", width: "90px" },
    { text: "Estado", value: "estado_envio", width: "110px" },
    { text: "", value: "acciones", sortable: false, align: "center", width: "50px" },
  ];

  // ── Computed from store ──
  public get mensajes(): manychat_mensajes_log[] {
    return manychatLogsModule.mensajes;
  }

  public get recordatorios(): recordatorio_cita_log[] {
    return manychatLogsModule.recordatorios;
  }

  public mounted() {
    this.cargarMensajes();
    this.cargarRecordatorios();
  }

  public async cargarMensajes() {
    this.loadingM = true;
    try {
      await manychatLogsModule.getMensajes({
        tipo_mensaje: this.filtroM.tipo_mensaje || undefined,
        estado_envio: this.filtroM.estado_envio || undefined,
        fecha_desde: this.filtroM.fecha_desde || undefined,
        fecha_hasta: this.filtroM.fecha_hasta || undefined,
      });
    } finally {
      this.loadingM = false;
    }
  }

  public async cargarRecordatorios() {
    this.loadingR = true;
    try {
      await manychatLogsModule.getRecordatorios({
        tipo_recordatorio: this.filtroR.tipo_recordatorio || undefined,
        estado_envio: this.filtroR.estado_envio || undefined,
        fecha_desde: this.filtroR.fecha_desde || undefined,
        fecha_hasta: this.filtroR.fecha_hasta || undefined,
      });
    } finally {
      this.loadingR = false;
    }
  }

  public limpiarFiltrosM() {
    this.filtroM = { fecha_desde: null, fecha_hasta: null, tipo_mensaje: null, estado_envio: null };
    this.cargarMensajes();
  }

  public limpiarFiltrosR() {
    this.filtroR = { fecha_desde: null, fecha_hasta: null, tipo_recordatorio: null, estado_envio: null };
    this.cargarRecordatorios();
  }

  public verDetalle(item: manychat_mensajes_log | recordatorio_cita_log, tipo: string) {
    this.detalleItem = item;
    this.detalleEsTipo = tipo;
    this.detalleOpen = true;
  }

  public formatFecha(valor: Date | string | null): string {
    if (!valor) return "—";
    const d = valor instanceof Date ? valor : new Date(valor);
    if (isNaN(d.getTime())) return String(valor);
    return d.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" })
      + " " + d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
  }

  public formatJson(json: string): string {
    if (!json) return "—";
    try {
      return JSON.stringify(JSON.parse(json), null, 2);
    } catch {
      return json;
    }
  }

  public labelTipo(tipo: string): string {
    const labels: Record<string, string> = {
      solicitud_procesando: "En proceso",
      cita_confirmada: "Confirmada",
      cita_rechazada: "Rechazada",
      cita_cancelada_admin: "Cancelada admin",
      cancelacion_paciente: "Cancelada paciente",
      recordatorio_120h: "Recordatorio 120h",
      recordatorio_72h: "Recordatorio 72h",
      recordatorio_24h: "Recordatorio 24h",
      recordatorio_2h: "Recordatorio 2h",
    };
    return labels[tipo] || tipo;
  }

  public colorTipo(tipo: string): { bg: string; text: string } {
    const map: Record<string, { bg: string; text: string }> = {
      solicitud_procesando:  { bg: "blue lighten-5",   text: "blue darken-2" },
      cita_confirmada:       { bg: "green lighten-5",  text: "green darken-2" },
      cita_rechazada:        { bg: "red lighten-5",    text: "red darken-2" },
      cita_cancelada_admin:  { bg: "orange lighten-5", text: "orange darken-2" },
      cancelacion_paciente:  { bg: "purple lighten-5", text: "purple darken-2" },
      recordatorio_120h:     { bg: "teal lighten-5",   text: "teal darken-2" },
      recordatorio_72h:      { bg: "teal lighten-5",   text: "teal darken-2" },
      recordatorio_24h:      { bg: "teal lighten-5",   text: "teal darken-2" },
      recordatorio_2h:       { bg: "teal lighten-5",   text: "teal darken-2" },
    };
    return map[tipo] || { bg: "grey lighten-3", text: "grey darken-2" };
  }

  public colorRecordatorio(tipo: string): { bg: string; text: string } {
    const map: Record<string, { bg: string; text: string }> = {
      "120h": { bg: "indigo lighten-5", text: "indigo darken-2" },
      "72h":  { bg: "blue lighten-5",   text: "blue darken-2" },
      "24h":  { bg: "cyan lighten-5",   text: "cyan darken-2" },
      "2h":   { bg: "teal lighten-5",   text: "teal darken-2" },
    };
    return map[tipo] || { bg: "grey lighten-3", text: "grey darken-2" };
  }
}
